<template>

  <div :class="purchaseRequired=='category' ? 'col-sm-10 category-ddl' : 'col-sm-10'">
    <div class="one-line"  v-if="purchaseRequired=='category' && !isHideMinDiscountQuantity">
      <legend v-if="purchaseRequired=='category'" class="col-sm-2 col-form-label">{{$t('coupon.min_discount_quantity')}}</legend>
      <div v-if="purchaseRequired=='category'" class="col-sm-10">
        <b-form-input type="number"
          class="form-control"
          v-model="min_discount_quantity"/>
      </div>
    </div>

    <div class="one-line">
      <legend v-if="purchaseRequired=='category'" class="col-sm-2 col-form-label">{{$t('coupon.category')}}</legend>
      <div v-if="purchaseRequired=='category'" class="col-sm-10">
        <multiselect v-model="data"
          :class="'margin-bottom10'"
          v-bind:placeholder="$t('coupon.select_categories')"
          label="text"
          track-by="value"
          :multiple="true"
          :options="categoryList"
          :close-on-select="false"
          :taggable="true"
          v-if="displayCategory"
                     v-bind:selectLabel = "$t('menu.select_label')"
                     v-bind:deselectLabel = "$t('menu.select_remove')"
                     v-bind:selectedLabel = "$t('menu.selected')"
        />
      </div>

      <div v-if="purchaseRequired!='category'" style="display: flex;">
        <legend v-if="displayCategoryLabel" class="col-sm-2 col-form-label" style="padding-left: 0; padding-right: 0;">{{$t('coupon.category')}}</legend>
        <div :class="displayCategoryLabel ? 'col-sm-10' : 'col-sm-12'" style="padding-left: 0; padding-right: 0;">
          <multiselect v-model="data"
            :class="'margin-bottom10'"
            v-bind:placeholder="$t('coupon.select_categories')"
            label="text" track-by="value"
            :multiple="true"
            :options="categoryList"
            :close-on-select="false"
            :taggable="true"
            v-if="displayCategory"
                       v-bind:selectLabel = "$t('menu.select_label')"
                       v-bind:deselectLabel = "$t('menu.select_remove')"
                       v-bind:selectedLabel = "$t('menu.selected')"
          />
        </div>
      </div>

      <div v-if="purchaseRequired=='category' && !isHideCrustSize">
        <legend class="col-sm-2 col-form-label">{{$t('coupon.size_required')}}</legend>
        <div class="col-sm-10 gray-light-background">
          <b-form-checkbox-group
            :options="firstLayerData"
            v-model="firstSelectedChild"
            plain />
            
        </div>
      </div>

      <div v-if="purchaseRequired=='category' && !isHideCrustSize">
        <legend class="col-sm-2 col-form-label">{{$t('coupon.crust_required')}}</legend>
        <div class="col-sm-10 gray-light-background">
          <b-form-checkbox-group
            :options="secondLayerData"
            v-model="secondSelectedChild"
            stacked
            plain />
        </div>
      </div>
    </div>

    <div v-if="purchaseRequired!='category'" style="display: flex;">
      <legend v-if="displayMenuLabel" class="col-sm-2 col-form-label" style="padding-left: 0; padding-right: 0;">{{$t('coupon.menu')}}</legend>
      <div :class="displayMenuLabel ? 'col-sm-10' : 'col-sm-12'" style="padding-left: 0; padding-right: 0;">
        <a v-if="purchaseRequired=='all' || purchaseRequired=='menu'" class="add-more" v-on:click="addParent()"><i class="fa fa-plus margin-top10 margin-bottom10"></i>{{$t('coupon.add_more')}}</a>
        <div v-if="purchaseRequired=='all' || purchaseRequired=='menu'" v-for="(parent, index) in items" :key="parent.id">
          <div class="gray-background">
            <div class="form-group row align-items-center">
              <div class="col-sm-8">
                <multiselect 
                     v-model="parent.parent_item_selected" 
                     :options="menusList" 
                     :multiple="false" 
                     group-values="items" 
                     group-label="group"
                     :group-select="false"
                     :class="invalidCrustNSizeItem(parent) ? 'is-invalid' : ''"
                     v-bind:placeholder="$t('common.name')" 
                     track-by="text" 
                     label="text"
                     @input="menuItemChange(parent)"
                     v-bind:selectLabel = "$t('menu.select_label')"
                     v-bind:deselectLabel = "$t('menu.select_remove')"
                     v-bind:selectedLabel = "$t('menu.selected')"
                     >
                </multiselect>
              </div>

              <div class="col-sm-3">
                <b-button v-if="needToAddCrustNSize(parent)" variant="primary" class="border-radius-4px pl-3 pr-3" v-on:click="addSizeCrust(parent)">
                  <i data-v-575aaa9b="" class="fa fa-plus"></i> 
                  {{$t('coupon.size_crust')}}
                </b-button>

                <b-button style="margin: 3px 0 3px 10px;" variant="danger" v-on:click="removeParent(index)" size="sm"><i class="fa fa-trash"></i></b-button>
              </div>
              <div class="col-sm-9" style="margin-left: 10px" v-if="invalidCrustNSizeItem(parent)">
                <b-form-invalid-feedback class="d-block font-size-inherit" id="discount_menu_items-feedback">
                  <p class="help is-danger mb-0">{{ $t('required_crust_size') }}</p>
                </b-form-invalid-feedback>
              </div>
            </div>
          </div>

          <div v-for="(child, child_index) in parent.list_child" :key="child_index">
            <div class="gray-light-background">
              
              <div class="form-group row">
                  <legend class="col-sm-1 col-form-label">{{$t('coupon.variant')}}</legend>
                  <div class="col-sm-4" >
                    <b-form-select
                      @input="sizeCrustChange(parent,child,$session.get('lang'))"
                      v-model="child.list_variant_selected" 
                      :options="child.list_variant[$session.get('lang')]" />
                  </div>
                  <template v-if="isEmpty(child.list_variant_selected) || (!isEmpty(child.list_variant_selected) && !isEmpty(child.list_add_on[$session.get('lang')]))">
                    <legend class="col-sm-1 col-form-label">{{$t('coupon.addon')}}</legend>
                    <div class="col-sm-4" style="padding-right: 5px;">
                      <b-form-select
                        v-model="child.list_add_on_selected" 
                        :options="child.list_add_on[$session.get('lang')]" />
                    </div>
                  </template>
                  <div class="col-sm-2 col-sm-2-custom">
                    <b-button variant="danger" v-on:click="removeSizeCrust(parent,child_index)" size="sm"><i class="fa fa-trash"></i></b-button>
                  </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .margin-bottom10{
    margin-bottom: 10px;
  }

  .add-more{
    padding-left: 0;
  }

  .add-more{
    color: #0086FF;
    cursor: pointer;
  }

  .add-more .fa{
    margin-right: 10px;
    font-size: 15px;
    border-radius: 50%;
    border: 1px solid #0086FF;
    width: 18px;
    height: 17px;
    color: #0086FF;
    padding-left: 2px;
  }

  .margin-top20{
    margin-top: 20px;
  }

  .margin-top10:first-child{
    margin-top: 10px;
  }

  .col-sm-2-custom-display-inline{
    flex: 0 0 12.66667%; 
    margin-top: 2px; 
    text-align: center;
    display: inline-flex;
  }

  .gray-light-background .btn-danger,
  .table-bordered .btn-danger{
    background-color: #F4F6F8; 
  }

  .gray-background .btn-danger{
      background-color: #E1E6EB;
  }

  .gray-background .btn-danger .fa, 
  .gray-light-background .btn-danger .fa, 
  .remark .btn-danger .fa, 
  .table-bordered .btn-danger .fa{
      color: #0086FF;
      font-size: 20px;
  }

  .gray-background .form-control{
    padding: 8px;
    border: 1px solid gray;
  }

  .gray-background{
    background: #E1E6EB;
    padding: 15px;
  }

  .gray-light-background{
    background: #F4F6F8;
    padding: 15px;
  }

  .gray-background .row{
    margin-bottom: 0px;
  }

  .category-ddl{
    display: inline-block;
  }

  .category-ddl .col-sm-2{
    padding-left: 0;
    padding-right: 0;
    float: left;
    padding-top: 15px;
  }

  .category-ddl .col-sm-10{
    padding: 0;
    float: right;
  }

  .category-ddl .gray-light-background{
    padding: 10px;
    margin-bottom: 10px;
  }

  .category-ddl .gray-light-background .col-sm-2{
    padding-top: 20px;
  }

  .one-line {
    clear: both;
    width: 100%;
  }
  .font-size-inherit {
    font-size: inherit;
  }
</style>

<style type="text/css">
  .category-ddl .gray-light-background .form-check{
    margin-bottom: 10px;
  }
</style>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'CustomAddMoreMenuItem',
  components: {
    Multiselect
  },
  props: {
    displayCategoryLabel: {
      default: false
    },
    displayMenuLabel: {
      default: false
    },
    purchaseRequired: {
      default: 'all'
    },
    displayCategory: {
      default: true
    },
    value: {
      required: false,
      default: ""
    },
    categoryList: {
      required: false,
      default: () => []
    },
    menusList: {
      required: true,
      default: () => []
    },
    menus: {
      required: true,
      default: []
    },
    firstLayerData: {
      required: false,
      default: () => []
    },
    secondLayerData: {
      required: false,
      default: () => []
    },
    languages: {
      required: true
    },
    items: {
      required: true
    },
    firstSelected: {
      required: false,
      default: () => []
    },
    secondSelected: {
      required: false,
      default: () => []
    },
    minDiscountQuantity: {
      required: false,
      default: 0
    },
    invalidCrustNSizeItem: {type: Function},
    needToAddCrustNSize: {type: Function},
    isHideMinDiscountQuantity: {
      required: false,
      default: false
    },
  },
  data: function () {
    return {
      data: this.value,
      isHideCrustSize: true,
      firstSelectedChild: [],
      secondSelectedChild: [],
      min_discount_quantity: this.minDiscountQuantity
    }
  },
  methods: {
    changeCategories () {
      this.$emit('input', this.data);
    },
    addParent () {
      this.items.push({
        menu_item:this.menus,
        parent_item_selected:"",
        list_child:[]
      })
    },
    removeParent (index) {
      this.items.splice(index, 1)
    },
    menuItemChange(p){
      p.list_child=[]
    },
    addSizeCrust(parent) 
    {
      if(!parent) return;
      parent.list_child.push({
        list_variant:this.getVariantByMenuId(parent.parent_item_selected),
        list_variant_selected:"",
        list_add_on: [],
        list_add_on_selected:"",
        deleted:0,
        id:0
      })
    },
    removeSizeCrust(parent,index) {
      parent.list_child.splice(index, 1)
    },
    sizeCrustChange(parent, menuItem, lang){
      if(!parent ||!menuItem || !menuItem.list_variant) return
      menuItem.list_add_on[lang]=[]
      var addon = _.find(menuItem.list_variant[lang], function (obj) 
      {
        return obj.value === menuItem.list_variant_selected; 
      });
      if(!addon) return
      menuItem.list_add_on[lang]=addon.addons;
    },
    getVariantByMenuId(parent){
      let langs = this.languages
      let variants=[]
      let add_on=[]
      
      for (let l in langs) 
      {
        variants[langs[l]] = []
        add_on[langs[l]] = []

        for (let f in parent.first_layers) 
        {
          let first = parent.first_layers[f]
          add_on[langs[l]][first['sku']] = []
          for (let s in first.second_layers) {
            let second = first.second_layers[s]
            if (second['name'] != null && second['name'][langs[l]] != undefined && second['name'][langs[l]] != '') {
              add_on[langs[l]][first['sku']].push({
                  value: second['sku'],
                  text: second['name'][langs[l]]
              })
            }
          }
          if (first['name'] != null && first['name'][langs[l]] != undefined && first['name'][langs[l]] != '') {
            variants[langs[l]].push({
                value: first['sku'],
                text: first['name'][langs[l]],
                addons:[],
                addon_selected:""
            })
          }
        }
      }

      //set add ons
      for (let l in langs) {
        for (let s in variants[langs[l]]) {
          variants[langs[l]][s].addons = add_on[langs[l]][variants[langs[l]][s].value]
        }
      }
      return variants;
    },
    checkPizzaCategory(data) {
      for (let f in data) {
        if (data[f]['sku']==='010') { //Pizza
          return true;
        }
      }
      return false;
    },
    showHideCrustSize(data) {
      if (data && data.length > 0 && this.checkPizzaCategory(data)) {
        this.isHideCrustSize = false
      } else {
        this.isHideCrustSize = true
        this.first_selected = []
        this.second_selected = []
      }
    }
  },
  created: function () {
    this.showHideCrustSize(this.value)
    this.firstSelectedChild = this.firstSelected
    this.secondSelectedChild = this.secondSelected
  },
  watch: {
    value: {
      handler: function (val, oldVal) {
        this.data = val
      },
      deep: true
    },
    items: {
      handler: function (val, oldVal) {
        this.$emit('change', this.items)
        this.$emit('input', this.data)
      },
      deep: true
    },
    data: {
      handler: function (val, oldVal) {
        this.showHideCrustSize(val)
        this.$emit('input', this.data)
      },
      deep: true
    },
    firstSelectedChild: {
      handler: function (val, oldVal) {
        this.$emit('changeFirstSelected', val)
      },
      deep: true
    },
    secondSelectedChild: {
      handler: function (val, oldVal) {
        this.$emit('changeSecondSelected', val)
      },
      deep: true
    },
    minDiscountQuantity: {
      handler: function (val, oldVal) {
        this.min_discount_quantity = val
      },
      deep: true
    },
    min_discount_quantity: {
      handler: function (val, oldVal) {
        this.$emit('changeMinDiscountQuantity', val)
      },
      deep: true
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/Partials/CustomAddMoreMenuItem.vue